// extracted by mini-css-extract-plugin
module.exports = {"icon":"Event_icon__uSlhY"};